/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseType } from '../../models/course-type';

export interface ApiMasterCourseTypeGetActiveGet$Params {
}

export function apiMasterCourseTypeGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterCourseTypeGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CourseType>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCourseTypeGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CourseType>>;
    })
  );
}

apiMasterCourseTypeGetActiveGet.PATH = '/api/Master/CourseType/GetActive';
